"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const unsubscribeBlockInputs = [
  {
    name: "successMessage",
    type: "string",
    required: true,
    defaultValue: "You've been successfuly removed from subscription list",
  },
  {
    name: "errorMessage",
    type: "string",
    required: true,
    defaultValue: "Something went wrong",
  },
] as const satisfies Inputs;

export const UnsubscribeBlockComponent: RegisteredComponent = {
  name: "UnsubscribeBlock",
  component: dynamic(async () =>
    withValidation(
      unsubscribeBlockInputs,
      (await import("./UnsubscribeBlock")).UnsubscribeBlock,
      "UnsubscribeBlock"
    )
  ),
  inputs: unsubscribeBlockInputs,
};
